/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_When_LabelInputs */

const en_us2_workout_quick_when_label = /** @type {(inputs: Workout_Quick_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When did you finish?`)
};

const pt_br2_workout_quick_when_label = /** @type {(inputs: Workout_Quick_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando você terminou?`)
};

const es_419_workout_quick_when_label = /** @type {(inputs: Workout_Quick_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuándo terminaste?`)
};

const pt_pt2_workout_quick_when_label = /** @type {(inputs: Workout_Quick_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando terminaste?`)
};

const fr_fr2_workout_quick_when_label = /** @type {(inputs: Workout_Quick_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quand as-tu fini ?`)
};

const de_de2_workout_quick_when_label = /** @type {(inputs: Workout_Quick_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wann warst du fertig?`)
};

const it_it2_workout_quick_when_label = /** @type {(inputs: Workout_Quick_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando hai finito?`)
};

/**
* | output |
* | --- |
* | "When did you finish?" |
*
* @param {Workout_Quick_When_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_when_label = /** @type {((inputs?: Workout_Quick_When_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_When_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_when_label(inputs)
	if (locale === "es-419") return es_419_workout_quick_when_label(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_when_label(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_when_label(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_when_label(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_when_label(inputs)
	return en_us2_workout_quick_when_label(inputs)
});
export { workout_quick_when_label as "workout-quick.when_label" }